import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'ot-grid-section-header',
  templateUrl: './grid-section-header.component.html',
  styleUrls: ['./grid-section-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridSectionHeaderComponent {
  @Input() title: string;
  @Input() hideFilterButton: boolean;
  @Output() filterButtonClick = new EventEmitter<Event>();

  onFilterButtonClick(event: Event) {
    event.stopPropagation();
    this.filterButtonClick.emit(event);
  }
}
